import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoginService} from '../../services/login.service';
import {WindowService} from '../../services/window.service';
import * as firebase from 'firebase';
import {LoadingDialogComponent} from '../../dialogs/loading-dialog/loading-dialog.component';
import {LocalConstants} from '../../beans/LocalConstants';
import {AngularFirestore} from '@angular/fire/firestore';
import { MatDialog } from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';
import {AngularFireAuth} from '@angular/fire/auth';
import {Router} from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

    windowRef: any;
    codeSent = false;


    // loaded = false;

    constructor(private router: Router, private loginService: LoginService, private win: WindowService, public db: AngularFirestore, public dialog: MatDialog, public toastService: ToastrService, public _auth: AngularFireAuth) {
    }

    private showError(error: string, title: string) {
        this.toastService.error(error, title);
    }

    ngOnInit() {


        this.windowRef = this.win.windowRef;


        this.windowRef.recaptchaVerifier = new firebase.default.auth.RecaptchaVerifier('recaptcha-container', {
            'size': 'invisible',
            'callback': function (response) {
                // console.log(response);
            }
        });
        this.windowRef.recaptchaVerifier.render();

        // console.log('loaded');
        //
        // this.loaded = true;

    }

    ngOnDestroy() {
    }

    loginUser(phoneNumberCode: string, phoneNumber: string) {

        if (!phoneNumber) {
            this.showError('Kindly Enter a Valid Mobile Number', 'Invalid Mobile Number');
            return;
        }


        const appVerifier = this.windowRef.recaptchaVerifier;
        const dialogRef = this.dialog.open(LoadingDialogComponent, {
            panelClass: "my-panel",
        });

        this.db.collection(LocalConstants.keysCollection, x => x.where('phoneNumber', '==', phoneNumber).limit(1)).get()
            .toPromise().then((result) => {

            if (result.docs.length <= 0) {
                dialogRef.close();
                this.showError('Kindly Tap on Register Here to Register', 'Mobile Number Not Registered.');
                return;
            }

            const account = result.docs[0].data();

            if (account['phoneNumberCode'] !== phoneNumberCode) {
                dialogRef.close();
                this.showError('Kindly Enter a valid country code', 'Invalid Country Code');
                return;
            }


            this._auth.signInWithPhoneNumber('+' + phoneNumberCode + phoneNumber, appVerifier)
                .then((confirmationResult) => {
                    dialogRef.close();
                    this.codeSent = true;
                    this.windowRef.confirmationResult = confirmationResult;
                })
                .catch(error => {
                    dialogRef.close();
                    if (error.code === 'auth/internal-error') {
                        this.showError('Please try again later.', 'Max OTP Limit Reached');
                    } else {
                        this.showError(error, 'Error');
                    }
                    // console.log('Error ' + error);
                });

        });

    }

    verifyLoginCode(verificationCode) {
        if (verificationCode.length !== 6) {
            this.showError('Kindly Enter a Valid 6 digit OTP', 'Invalid OTP');
            return;
        }
        const dialogRef = this.dialog.open(LoadingDialogComponent, {
            panelClass: "my-panel",
        });
        this.windowRef.confirmationResult
            .confirm(verificationCode)
            .then(result => {
                dialogRef.close();

            })
            .catch(error => {
                // console.log(error, 'Incorrect code entered?'),
                dialogRef.close();
                this.showError('Kindly Enter a Valid 6 digit OTP', 'Incorrect code entered?');
            });
    }


}
